// Font settings
export const FONT_FAMILY = 'Roboto, "Helvetica Neue", Arial, sans-serif';

// Chart dimensions and spacing
export const CHART_DIMENSIONS = {
    MARGIN: {
        TOP: 30,
        RIGHT: 30,
        LEFT_OFFSET: 120,
        BOTTOM: 30
    },
    BAR: {
        MIN_SIZE: 50,
        SIZE_INCREMENT: 8,
    },
    ITEM: {
        BASE_HEIGHT: 60,
        LINE_HEIGHT: 35,
    },
    PADDING: {
        CONTAINER: 4,
        CHART_BOTTOM: 150,
    }
};

// Text styles with explicit font settings
export const TEXT_STYLES = {
    AXIS_LABEL: {
        fontSize: '20px',
        fontWeight: 500,
        fontFamily: FONT_FAMILY,
    },
    MULTILINE_LABEL: {
        fontSize: '20px',
        fontWeight: 500,
        lineSpacing: 28,
        fontFamily: FONT_FAMILY,
    },
    PERCENTAGE_LABEL: {
        fontSize: '20px',
        fontWeight: 700,
        textShadow: '0 .1px 1px rgba(0,0,0,0.8)',
        fontFamily: FONT_FAMILY,
    },
    AVERAGE_LINE: {
        fontSize: '13px',
        fontWeight: 500,
        fontFamily: FONT_FAMILY,
    },
    AXIS_TICK: {
        fontSize: '13px',
        fontWeight: 400,
        fontFamily: FONT_FAMILY,
    },
    LEGEND: {
        fontSize: '20px',
        fontFamily: FONT_FAMILY,
        paddingBottom: '20px',
        iconSize: 23,
        marginLeft: 0,
        marginRight: 0,
        itemMarginTop: 10,
        itemMarginBottom: 5
    }
};

// Title styles
export const TITLE_STYLES = {
    fontSize: '1.25rem',
    fontWeight: 500,
    marginBottom: '24px',
    color: 'rgba(0, 0, 0, 0.87)'
};

// Paper styles with transitions
export const PAPER_STYLES = {
    CONTAINER: {
        p: 4,
        backgroundColor: 'unset',
        borderRadius: 2,
        flex: '0 1 80%',
        boxShadow: 'unset',
        transition: 'all 0.3s ease-in-out',
        '& .transitioning': {
            opacity: 0,
            transition: 'opacity 0.3s ease-in-out'
        },
        '& .recharts-wrapper': {
            transition: 'opacity 0.3s ease-in-out'
        }
    }
};

// Chart type options
export const CHART_TYPES = {
    BAR: 'bar',
    PIE: 'pie',
    RADAR: 'radar',
    TABLE: 'table'
};

// Export options with explicit font settings
export const EXPORT_OPTIONS = {
    SCALE: 2,
    BACKGROUND: '#ffffff',
    FONT_FAMILY: FONT_FAMILY,
};

// Animation configurations
export const ANIMATION_CONFIG = {
    DURATION: 300,
    EASING: 'ease-in-out'
};

// Chart container styles
export const CHART_CONTAINER_STYLES = {
    position: 'relative',
    width: '100%',
    height: '100%',
    transition: 'all 0.3s ease-in-out'
};

// Form control styles
export const FORM_CONTROL_STYLES = {
    minWidth: 200,
    '& .MuiInputBase-root': {
        transition: 'all 0.2s ease-in-out'
    }
};
